(ns bec-cljs-common.core
  (:require [tick.timezone] ;; NOTE: DO NOT REMOVE THIS REF. https://github.com/juxt/tick/blob/cde9797caf508d2caa2c088a9b0dbbbcc971ba42/docs/cljs.adoc
            [bec-cljs-common.config :as config]
            [bec-cljs-common.re-frame.subs]
            [bec-cljs-common.re-frame.events]
            [bec-cljs-common.re-frame.effects]
            [bec-cljs-common.booking]
            [bec-cljs-common.session]
            [bec-cljs-common.light-control]))


;; Rationale: I don't want to worry about the current initialization setup for re-frame (there are several ways to do it) - as this might change over time and between apps. I.e. this should be called before subs are added, the app-db is initialized and so on.
(defn init! "For stuff that should be around before re-frame subs are compiled, the app-db is initialized and so on." ;; TODO: Just pass in a map and assert for must-exist fields?
  [app-category app-type app-server-url client-state-path stream-name]
  (set! config/app-category app-category)
  (set! config/app-type app-type)
  (set! config/app-server-url app-server-url)
  (set! config/client-state-path client-state-path)
  (set! config/stream-name stream-name))


(def path config/path)
